import { FC } from 'react';
import cx from 'classnames/bind';
import { motion, AnimatePresence } from 'framer-motion';

import { Pack } from '@/components/Training/Pack';
import type { IMiniGame } from '@/types/miniGames';
import type { IPack } from '@/types/pack';

import styles from './Packs.module.scss';

interface PacksProps {
  setStep: (value: number) => void;
  questionNumber: number;
  setIsShake: (value: boolean) => void;
  currentQuestion?: IMiniGame;
  miniGames?: IMiniGame[];
}

const cn = cx.bind(styles);

const Packs: FC<PacksProps> = ({
  setStep,
  questionNumber,
  setIsShake,
  currentQuestion,
  miniGames,
}) =>
  currentQuestion?.cigarettes && currentQuestion?.cigarettes.length > 0 ? (
    <div className={cn('list-wrapper')}>
      <AnimatePresence>
        <motion.ul
          key={questionNumber}
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{
            position: 'absolute',
            bottom: 0,
            opacity: 0,
          }}
          transition={{ duration: 1, ease: 'backInOut' }}
          className={cn('list')}
        >
          {currentQuestion.cigarettes.map((item: IPack) => (
            <Pack
              key={item.id}
              setStep={setStep}
              questionNumber={questionNumber}
              setIsShake={setIsShake}
              pack={item}
              miniGames={miniGames}
            />
          ))}
        </motion.ul>
      </AnimatePresence>
    </div>
  ) : null;
export default Packs;
